import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let winWidth;

function calculateDistance(elem, mouseX, mouseY) {
  return Math.floor(
    Math.sqrt(
      // eslint-disable-next-line no-restricted-properties
      Math.pow(mouseX - (elem.offset().left + elem.width() / 2), 2) +
        // eslint-disable-next-line no-restricted-properties
        Math.pow(mouseY - (elem.offset().top + elem.height() / 2), 2)
    )
  );
}

function magnetize(el, e, o) {
  const mX = e.pageX;
  const mY = e.pageY;
  const item = $(el);
  let offset = o;

  if (winWidth < 768) {
    offset /= 2;
  } else {
    offset = o;
  }

  const customDist = item.data('dist') * offset || offset * 6;
  const centerX = item.offset().left + item.width() / 2;
  const centerY = item.offset().top + item.height() / 2;

  const deltaX = Math.floor(centerX - mX) * -0.45;
  const deltaY = Math.floor(centerY - mY) * -0.45;

  const distance = calculateDistance(item, mX, mY);

  if (distance < customDist) {
    gsap.to(item, 0.5, { y: deltaY, x: deltaX, scale: 1.1 });
    item.addClass('magnet');
  } else {
    gsap.to(item, 0.6, { y: 0, x: 0, scale: 1 });
    item.removeClass('magnet');
  }
}

class ModuleSubHeader {
  init() {
    this.animate();
    this.initListener();
    this.initParallax();
    this.onScroll();
    this.onResize();
  }

  animate() {
    this.timeout = setTimeout(function () {
      $('.header_image_container').addClass('show');
    }, 500);

    this.timeout = setTimeout(function () {
      $('.header_headline').addClass('show');
    }, 1000);

    this.timeout = setTimeout(function () {
      $('.header_bubble_phone').addClass('show');
    }, 1800);

    setTimeout(function () {
      $('.header_bubble_mail').addClass('show');
    }, 2200);
  }

  initListener = () => {
    $(document).on('mousemove touch', function (e) {
      magnetize($('.header_bubble_news'), e, 12);
      magnetize($('.header_bubble_phone'), e, 9);
      magnetize($('.header_bubble_mail'), e, 7);
    });

    $('.header_bubble_phone').on('mouseover', function () {});
    $('.header_bubble_phone').on('mouseout', function () {});
  };

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#header',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        markers: false
      }
    });

    gsap.utils.toArray('.header_image').forEach((layer) => {
      //let { depth } = layer.dataset.depth;
      const depth = 0.5;
      const movement = -(layer.offsetHeight * depth);

      tl.to(layer, { y: -movement, ease: 'none' }, 0);
    });

    gsap.to('.header_bubbles', {
      scrollTrigger: {
        trigger: '.header_bubbles',
        start: 'bottom 90%',
        end: 'bottom 0%',
        markers: false,
        scrub: 0.5
      },
      scale: 0.8
    });

    gsap.to('.logo', {
      scrollTrigger: {
        trigger: '#header',
        start: 'center center',
        end: 'bottom 20%',
        markers: false,
        scrub: 0.5
      },
      scale: 0.7
    });

    gsap.to('.top-nav', {
      scrollTrigger: {
        trigger: '#header',
        start: 'center 20%',
        end: 'center 22%',
        markers: false,
        scrub: 0
      },
      autoAlpha: 0
    });

    gsap.to('.header_bubble_phone', {
      scrollTrigger: {
        trigger: '#googlemap',
        start: 'bottom 90%',
        end: 'bottom 80%',
        markers: false,
        scrub: 0
      },
      autoAlpha: 0,
      scale: 0.5
    });

    gsap.to('.header_bubble_mail', {
      scrollTrigger: {
        trigger: '#googlemap',
        start: 'bottom 90%',
        end: 'bottom 80%',
        markers: false,
        scrub: 0
      },
      autoAlpha: 0,
      scale: 0.5
    });
  };

  onScroll = () => {
    $(window)
      .scroll(function () {})
      .scroll();
  };

  onResize = () => {
    $(window)
      .resize(function () {
        winWidth = $(window).width();
      })
      .resize();
  };
}

export default ModuleSubHeader;
